import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const TraitIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M12.49 2.128a1 1 0 0 0-.98 0l-8 4.5a1 1 0 0 0 0 1.744L5.96 9.75l-2.45 1.38a1 1 0 0 0 0 1.743l2.45 1.379-2.45 1.378a1 1 0 0 0 0 1.743l8 4.5a1 1 0 0 0 .98 0l8-4.5a1 1 0 0 0 0-1.743l-2.45-1.378 2.45-1.379a1 1 0 0 0 0-1.743l-2.45-1.38 2.45-1.378a1 1 0 0 0 0-1.744l-8-4.5Zm3.51 8.77-3.51 1.974a1 1 0 0 1-.98 0L8 10.898 6.04 12 12 15.353l5.96-3.352L16 10.898Zm-4-.045L6.04 7.5 12 4.147 17.96 7.5 12 10.853ZM6.04 16.5 8 15.398l3.51 1.974a1 1 0 0 0 .98 0L16 15.398l1.96 1.102L12 19.854 6.04 16.5Z", clipRule: "evenodd" }));
});
TraitIcon.displayName = "TraitIcon";
